import api from './api';

export interface LoginResponse {
  access_token: string;
  user: {
    id: number;
    email: string;
    nom: string;
    prenom: string;
    role: string;
    boutiqueId: number | null;
    boutiqueNom: string | null;
    entrepriseId: number | null;
  };
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', {
      email,
      password,
    });
    localStorage.setItem('nexacom_token', response.data.access_token);
    localStorage.setItem('nexacom_user', JSON.stringify(response.data.user));
    return response.data;
  },

  async loginGoogle(idToken: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/google', { idToken });
    localStorage.setItem('nexacom_token', response.data.access_token);
    localStorage.setItem('nexacom_user', JSON.stringify(response.data.user));
    return response.data;
  },

  async changerMotDePasse(ancien: string, nouveau: string): Promise<{ message: string }> {
    const response = await api.post('/auth/changer-mot-de-passe', { ancien, nouveau });
    return response.data;
  },

  logout() {
    localStorage.removeItem('nexacom_token');
    localStorage.removeItem('nexacom_user');
  },

  getUser() {
    const user = localStorage.getItem('nexacom_user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('nexacom_token');
  },
};